import { QUOTES_ROUTES, QUOTE_NAVIGATION } from "./containers/quotes/routes"
import {
  INVOICES_NAVIGATION,
  INVOICES_ROUTES
} from "./containers/invoices/routes"
import {
  SETTINGS_ROUTES
  // SETTINGS_NAVIGATION
} from "./containers/settings/routes"
import { ACCOUNT_ROUTES } from "./containers/account/routes"
import {
  EMBARGOES_ROUTES,
  EMBARGOES_NAVIGATION
} from "./containers/embargoes/routes"
import { USERS_ROUTES, USERS_NAVIGATION } from "./containers/users/routes"
import {
  POLICIES_NAVIGATION,
  POLICIES_ROUTES
} from "./containers/policies/routes"

import {
  OPPORTUNITIES_NAVIGATION,
  OPPORTUNITIES_ROUTES
} from "./containers/opportunities/routes"
import { BROKERS_NAVIGATION, BROKERS_ROUTES } from "containers/brokers/routes"
import { CLAIMS_ROUTES } from "containers/claims/routes"
import { CLIENTS_ROUTES, CLIENTS_NAVIGATION } from "containers/clients/routes"
import { ERIC_NAVIGATION, ERIC_ROUTES } from "containers/eric/routes"
import { REPORTS_NAVIGATION, REPORTS_ROUTES } from "containers/reports/routes"
import {
  BLACKLIST_NAVIGATION,
  BLACKLIST_ROUTES
} from "containers/blocklist/routes"
import { RATINGS_NAVIGATION, RATINGS_ROUTES } from "containers/ratings/routes"
import {
  FAILED_RENEWALS_NAVIGATION,
  FAILED_RENEWALS_ROUTES
} from "containers/failed-renewals/routes"
import { API_LOG_NAVIGATION, API_LOG_ROUTES } from "containers/api-logs/routes"
import {
  AI_AGENTS_NAVIGATION,
  AI_AGENTS_ROUTES
} from "containers/ai-agents/routes"
import { DOCUMENTS_ROUTES } from "containers/documents/routes"

export const MAIN_ROUTES = [
  ...QUOTES_ROUTES,
  ...OPPORTUNITIES_ROUTES,
  ...EMBARGOES_ROUTES,
  ...ACCOUNT_ROUTES,
  ...POLICIES_ROUTES,
  ...BROKERS_ROUTES,
  ...USERS_ROUTES,
  ...SETTINGS_ROUTES,
  ...INVOICES_ROUTES,
  ...CLAIMS_ROUTES,
  ...CLIENTS_ROUTES,
  ...ERIC_ROUTES,
  ...REPORTS_ROUTES,
  ...BLACKLIST_ROUTES,
  ...RATINGS_ROUTES,
  ...FAILED_RENEWALS_ROUTES,
  ...API_LOG_ROUTES,
  ...AI_AGENTS_ROUTES,
  ...DOCUMENTS_ROUTES
]
export const NAVIGATION: TNavigation[] = [
  ...CLIENTS_NAVIGATION,
  ...OPPORTUNITIES_NAVIGATION,
  ...QUOTE_NAVIGATION,
  // ...SETTINGS_NAVIGATION,
  // TODO: This is for phase 2 of Westcor
  ...POLICIES_NAVIGATION,
  ...EMBARGOES_NAVIGATION,
  ...INVOICES_NAVIGATION,
  ...USERS_NAVIGATION,
  ...ERIC_NAVIGATION,
  ...REPORTS_NAVIGATION,
  ...BLACKLIST_NAVIGATION,
  ...RATINGS_NAVIGATION,
  ...FAILED_RENEWALS_NAVIGATION,
  ...API_LOG_NAVIGATION,
  ...AI_AGENTS_NAVIGATION,
  ...BROKERS_NAVIGATION
]

export type TNavigation = {
  title: string
  path: string
  childPaths?: string[]
  submenu: boolean
  permission?: string | string[]
  groups?: string[]
  icon: React.ReactNode
  iconActive: React.ReactNode
  version?: string
}
